import { ValueProvider } from '@angular/core';
import { SharedConfig } from './util-config/token/shared-config.interface';
import { SHARED_CONFIG } from './util-config/token/shared-config.token';
import { AuthConfig } from './interfaces/auth.interface';
import { AUTH_CONFIG } from './token/auth.token';

const getSharedConfigProvider = (value: SharedConfig): ValueProvider => ({
  provide: SHARED_CONFIG,
  useValue: value,
});

export function provideSharedDomain(sharedConfig: SharedConfig) {
  return [getSharedConfigProvider(sharedConfig)];
}

const getAuthProvider = (value: AuthConfig): ValueProvider => ({
  provide: AUTH_CONFIG,
  useValue: value,
});

export function provideCognitoAuth(config: AuthConfig) {
  return [getAuthProvider(config)];
}
